import React from "react"
import { graphql, useStaticQuery } from 'gatsby';
import Img from 'gatsby-image';

import Navbar from 'react-bootstrap/Navbar'
import Nav from 'react-bootstrap/Nav'

import { Link } from "@reach/router";

import useScrollPosition from '@react-hook/window-scroll'

import './navbar.css'

import { PrimaryButton, LinkButton } from '../styled-components/maesh-buttons'

const LandingNavbar = () => {

    const navbarImages = useStaticQuery(graphql`
    query {
        maeshLogo: file(relativePath: { eq: "maesh-horizontal.png" }) {
        childImageSharp {
            fixed(width: 146) {
            ...GatsbyImageSharpFixed_noBase64
            }
        }
        }
    }
    `)

    const scrollY = useScrollPosition(60)

    return (
        <Navbar expand="lg" className={scrollY > 0 ? "nav-scrolled" : ""}>
            <Navbar.Brand>
                <Link to="/">
                <Img
                    fixed={navbarImages.maeshLogo.childImageSharp.fixed}
                    alt="Maesh Logo"
                    className="brand-icon"
                    loading="eager" 
                />
                </Link>
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="navbarSupportedContent"></Navbar.Toggle>
            <Navbar.Collapse id="navbarSupportedContent">
                <Nav className="mr-auto">
                    <Nav.Link href="https://maesh.io/blog" target="_blank">
                        Blog
                        </Nav.Link>
                    <Nav.Link as={Link} to="consumers" target="_blank">
                        Consumers
                        </Nav.Link>
                    <Nav.Link href="https://maesh.io/docs" target="_blank">
                        Docs
                        </Nav.Link>
                    <Nav.Link as={Link} to="referrals" target="_blank">
                        Referrals
                        </Nav.Link>
                    <Nav.Link href="https://maesh.io/docs/faq" target="_blank">
                        FAQ
                        </Nav.Link>
                </Nav>
                <Nav className="ml-auto dashboard-links">
                    <Nav.Link href="https://dashboard.maesh.io/accounts/login">
                        <LinkButton>
                            Login
                            </LinkButton>
                    </Nav.Link>
                </Nav>
            </Navbar.Collapse>
            <div>
              <div class="alert alert-danger shutdown-banner" role="alert">
                Maesh is ceasing operations for its payments services on Thursday, January 28, 2021 at 8PM. Read our announcement <a href="/ceasing-operations"> here </a>
                </div>
            </div>
        </Navbar>
    )
}

export default LandingNavbar;
